import { useIntl } from 'react-intl';
import { Divider, Form } from 'antd';

import { PageProps } from '@/types/PageProps';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import BankingEntryForm from '@/components/Financial/Accounts/BankingEntry/BankingEntryForm';
import { useCreateBankingEntry } from '@/core/domain/financial/BankingEntry/BankingEntry.hooks';
import {
  BankingEntryCreateRequest,
  BankingEntryFormValues,
} from '@/core/domain/financial/BankingEntry/BankingEntry.types';
import { useHistory } from 'react-router-dom';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

function BankingEntryCreatePage({ route }: PageProps) {
  const intl = useIntl();
  const history = useHistory();

  const [form] = Form.useForm<BankingEntryFormValues>();

  const createMutation = useCreateBankingEntry();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();
      const obj: BankingEntryCreateRequest = {
        ...values,
        launchDate: values.launchDate.toISOString(),
        conciliationDate: values.launchDate.toISOString(),
      };

      const response = await createMutation.mutateAsync(obj);

      history.push(`/app/financial/bankingEntry/${response.id}`);
    } catch {}
  };

  return (
    <TabContentWrapper
      title={route.name}
      permissions={route.permissions}
      extra={
        <SpaceForButton>
          <SaveButton
            block
            type="primary"
            onClick={handleSaveClick}
            loading={createMutation.isLoading}
            disabled={
              !hasPermissions([Authorities.FINANCIAL_BANKING_ENTRIES_ADD])
            }
          >
            {intl.formatMessage({ id: 'commons.form.button.save' })}
          </SaveButton>
        </SpaceForButton>
      }
    >
      <BankingEntryForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/financial/bankingEntry" />
      </SpaceForButton>
    </TabContentWrapper>
  );
}

export default BankingEntryCreatePage;
